import type { CompactFieldItemProps } from "../types";
import { useTranslations } from "next-intl";

export function CompactFieldItem({
	fieldType,
	onAddField,
}: CompactFieldItemProps) {
	const t = useTranslations("fields");
	const Icon = fieldType.icon;

	return (
		<button
			className="flex items-center gap-2 rounded-2xl border border-border bg-background p-3 text-left transition-colors hover:bg-muted"
			onClick={() => onAddField(fieldType.type)}
		>
			<Icon className="size-4 flex-shrink-0 text-muted-foreground" />
			<span className="truncate font-medium text-xs">{t(`types.${fieldType.type}.label`)}</span>
		</button>
	);
}
